import { getToken } from "./adalConfig";
import axios from 'axios';

let baseUrl = 'https://test-grafokett-admin-api.azurewebsites.net';

// Local development
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    baseUrl = 'http://localhost:5011';
}

// Add token dynamically for each request using an interceptor
axios.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

if (window.location.hostname.includes('test')) {
    baseUrl = 'https://test-grafokett-admin-api.azurewebsites.net';
}

if (window.location.hostname.includes('prod')) {
    baseUrl = 'https://prod-grafokett-admin-api.azurewebsites.net';
}

console.log(baseUrl)

const apiSettings = {
    
    //HTTP GET 
    //ALL ORGANISATIONS
    getOrganizations: async () =>{
        return await axios.get(`${baseUrl}/api/organizations`)
    },
    getOrganizationsByName: async (name) =>{
        return await axios.get(`${baseUrl}/api/organizations/name/${name}`)
    },
    //ONE ORGANISATION
    getOrganization: async (organizationId) =>{
        return await axios.get(`${baseUrl}/api/organizations/${organizationId}`)
    },    
   

    //MaxUser || maxPrinters...
    getMaxUsers: async (organizationId) => {
        return await axios.get(`${baseUrl}/api/organizations/current/users/${organizationId}`)
    },
   
    getMaxPrinters: async (organizationId) => {
        return await axios.get(`${baseUrl}/api/organizations/current/printers/${organizationId}`)
    },
  
    getMaxLabels: async (organizationId) => {
        return await axios.get(`${baseUrl}/api/organizations/current/labels/${organizationId}`)
    },

    //HTTP POST
    postOrganization: async(organization) =>{
       return await axios.post(`${baseUrl}/api/organizations`, organization)
    },

    //HTTP PUT
    putOrganization: async (organization) =>{
        return await axios.put(`${baseUrl}/api/organizations`, organization)
    },

    // GET SUBSCRIPTION-TYPES
    getSubscriptionValues: async () => {
        return await axios.get(`${baseUrl}/api/organizations/subscriptions/types`)
    },

    // HTTP POST - Support User
    createSupportUser: async (organizationId) => {
        return await axios.post(`${baseUrl}/api/organizations/${organizationId}/support-user`)
    },
    // HTTP GET - Organization Users
    getOrganizationUsers: async (organizationId) => {
        try {
            const response = await axios.get(`${baseUrl}/api/organizations/${organizationId}/users`);
            return response;
        } catch (error) {
            throw error;
        }
    },
    getNotificationRecipients: async (activeOnly, tier, organizationId = null, organizationName = null, roles = null) => {
        const params = {};
        if (activeOnly) params.activeOnly = true;
        if (tier) params.tier = tier;
        if (organizationId) params.organizationId = organizationId;
        if (organizationName) params.organizationName = organizationName;
        if (roles && roles.length > 0) {
            roles.forEach(role => {
                params.roles = params.roles || [];
                params.roles.push(role);
            });
        }
        const fullUrl = `${baseUrl}/api/notifications/users`;
        try {
            const response = await axios.get(fullUrl, { params });
            return response;
        } catch (error) {
            throw error;
        }
    },
    sendNotification: async (body) => {
        return await axios.post(`${baseUrl}/api/notifications/send`, body);
    },

    // MyOrdersSettings
    getMyOrdersSettings: async (organizationId) => {
        return await axios.get(`${baseUrl}/api/organizations/${organizationId}/my-orders-settings`);
    },

    updateMyOrdersSettings: async (organizationId, settings) => {
        return await axios.put(`${baseUrl}/api/organizations/${organizationId}/my-orders-settings`, settings);
    },

    // Subscription lifecycle (Epic C)
    updateOrganizationEndDate: async (organizationId, endDate) => {
        return await axios.put(`${baseUrl}/api/organizations/${organizationId}/end-date`, endDate);
    },

    deleteOrganizationEndDate: async (organizationId) => {
        return await axios.delete(`${baseUrl}/api/organizations/${organizationId}/end-date`);
    },

    setOrganizationStatus: async (organizationId, status) => {
        return await axios.put(`${baseUrl}/api/organizations/${organizationId}/status`, { status });
    },

    deleteOrganization: async (organizationId) => {
        return await axios.delete(`${baseUrl}/api/organizations/${organizationId}`);
    },

    // Tenant data cleanup (Epic D — see output/HANDOFF-tenant-data-cleanup.md).
    // Runs in the background on the API (see output/CHANGELOG-tenant-cleanup-batching.md —
    // large tenants take longer than Azure App Service's fixed 230s request timeout):
    // startTenantDataCleanup queues the run and returns a runId, getTenantDataCleanupStatus
    // polls it until Status is Completed/Failed.
    startTenantDataCleanup: async (organizationId, body) => {
        return await axios.post(`${baseUrl}/api/organizations/${organizationId}/data-cleanup`, body);
    },

    getTenantDataCleanupStatus: async (organizationId, runId) => {
        return await axios.get(`${baseUrl}/api/organizations/${organizationId}/data-cleanup/${runId}`);
    }
}

export default apiSettings;